import { customScrollMinimal } from '@toggle/design-system';
import styled from 'styled-components';

export const ScenarioTableRoot = styled.div`
  ${customScrollMinimal};
  overflow: auto;
  flex: 1 1 0;
  z-index: 1;
`;

export const Footer = styled.div`
  padding: 8px 0;
`;
